<template>
<div>
  <PartnersHeader class="mt-6 lg:my-6 xl:my-6 header mx-auto" />
    <div class=" h-full min-h-screen pb-8 md:container mx-auto  w-ninety" :key="slot_uuid" style="background-color: white">
        <menu-order></menu-order >
        <slot  />
    </div>

    </div>
</template>

<script>
import MenuOrder from '../views/partners/menuOrder.vue';
import MozFooter from '@/views/home-page-layouts/home-footer';
import PartnersHeader from '@/helpers/partners-header.vue';
import client from '@/clients/partners';
import uuid from 'uuid/v4';
import { mapActions } from 'vuex';

export default {
  components: { MenuOrder, PartnersHeader, MozFooter },
  created() {
    if (this.user.role !== 'partner' && this.user.role !== 'editor' && this.user.role !== 'event_organizer' || !this.user.is_approved) {
      this.$router.push('/');
    }
    client.get('/me')
      .then(({ data }) => {
        this.setUser(data);
      });
    this.slot_uuid = uuid();
  },
  data() {
    return {
      slot_uuid: '',
    };
  },
  methods: {
    ...mapActions(['setUser']),
  },
  computed: {
    user() {
      return this.$store.getters.userInfo;
    },
  },
  watch: {
    user() {
      this.slot_uuid = uuid();
    },
  },
};
</script>
<style  scoped>
 .w-ninety {
  width: 80%;
    }

  .header {
    width: 80%;
  }
@media (max-width: 860px) {
   .header {
        width: 90%;
    }
      .w-ninety {
  width: 90%;
    }
}
</style>
